module.exports = __webpack_public_path__ + "img/ic_weicha.bfc71c7e.png";